module.exports = __webpack_public_path__ + "static/media/house.5ed53723.png";